import { Result } from '@synergetx/puppet-interview-types';
import { collection, getDocs } from 'firebase/firestore';
import { updateObject } from './firestore-utils';
import { firestore } from './firebaseConfig';
import { breadcrumb } from '../logging';

const INTERVIEWS = 'Interviews';
const GROUPS = 'Groups';
const RESULTS = 'Results';

/**
 * Reads every result for a survey, throwing if the read fails. Deliberately not `getItemsWhere`,
 * which resolves `[]` on failure and so makes a permission-denied read indistinguishable from a
 * survey with no data — that showed "No results yet" to researchers whose data was unreachable.
 */
export const getAllResults = async (groupId: string, interviewId: string): Promise<Result[]> => {
    const path = `${GROUPS}/${groupId}/${INTERVIEWS}/${interviewId}/${RESULTS}`;

    breadcrumb('getAllResults', 'firestore', { path });

    const snapshot = await getDocs(collection(firestore, path));

    return snapshot.docs.map((item) => ({ id: item.id, ...item.data() }) as Result);
};

export const deleteResult = async ({ groupId, interviewId, id }: Result): Promise<Result> =>
    updateObject<Result>(
        { id, deleted: true },
        `${GROUPS}/${groupId}/${INTERVIEWS}/${interviewId}/${RESULTS}`,
        'deleteResult',
    );

export const restoreResult = async ({ groupId, interviewId, id }: Result): Promise<Result> =>
    updateObject<Result>(
        { id, deleted: false },
        `${GROUPS}/${groupId}/${INTERVIEWS}/${interviewId}/${RESULTS}`,
        'restoreResult',
    );
